import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "placeholder", "value", "autocomplete"]
const _hoisted_3 = {
  key: 1,
  class: "tw-absolute tw-z-50 tw-mt-1 tw-w-full tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-shadow-lg tw-max-h-60 tw-overflow-y-auto"
}
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "rootRef",
    class: _normalizeClass(["tw-w-full tw-relative", _ctx.largeWidth ? 'tw-max-w-lg' : ''])
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.id,
          class: "tw-block tw-mb-1 tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500"
        }, _toDisplayString(_ctx.label), 9, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      ref: "inputRef",
      id: _ctx.id,
      type: "text",
      placeholder: _ctx.placeholder,
      value: _ctx.modelValue,
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
      onKeydown: [
        _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleEnter && _ctx.handleEnter(...args)), ["enter"])),
        _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.clearSuggestions && _ctx.clearSuggestions(...args)), ["esc"]))
      ],
      autocomplete: _ctx.autocomplete,
      class: "tw-w-full tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 tw-shadow-sm focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-indigo-500/15 focus:tw-border-indigo-500/55"
    }, null, 40, _hoisted_2),
    (_ctx.suggestions.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestions, (s, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              onClick: ($event: any) => (_ctx.selectSuggestion(index)),
              class: "tw-px-3 tw-py-2 tw-cursor-pointer hover:tw-bg-slate-50"
            }, _toDisplayString(s.displayText), 9, _hoisted_4))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}